// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"b0f5beb9","513":"784650db","703":"b161e6cf","787":"e69ca320"}[chunkId] + ".chunk.js";
};